import React, { useEffect } from 'react';
import { useAuth } from 'fennec-ui';

export default function LogoutAll(props) {
	const auth = useAuth();
  useEffect(() => {
    auth.fetch(`/api/logoutall`).then(res => {
        var nurl = new URL(window.location.href);
        var refUrl = nurl.searchParams.get("service");
        if (refUrl) {
          window.location.href = refUrl; //auth.schemhttp+"://auth."+auth.getDomainWithoutSubdomain(window.location.href)+"/login?service="+refUrl;
          return
        } else {
          window.location.href = "/login";
          return
        }
    })
	}, []);

	return (
		<>
		</>
	);
}